import { ModuleHubLayout } from "../../components/shell/ModuleHubLayout";
import { filterFlexxiNavSections } from "../../config/navigation";
import { useAuth } from "../../stores/auth";

export function FlexxiModuleLayout() {
  const { can, moduleEnabled } = useAuth();
  const sections = filterFlexxiNavSections(can, moduleEnabled);

  return (
    <ModuleHubLayout
      title="FlexxiPlan"
      subtitle="Instalment templates and contracts"
      sections={sections}
    />
  );
}
